import { onReady } from "/Assets/js/common/utilities.js";

onReady(() => {
    const hasPopovers = document.querySelector('[data-toggle="popover"]');
    const hasTooltips = document.querySelector('[data-toggle="tooltip"]');

    if (hasPopovers || hasTooltips) {
        import(/* webpackChunkName: "popover" */ "/Assets/libs/PopoverTooltip/popover-tooltip.js").then((module) => {
            module.initializePopovers();
            module.initializeTooltips();
        });
    }
});